import { render, staticRenderFns } from "./AllContractMag.vue?vue&type=template&id=1770fa04&scoped=true&"
import script from "./AllContractMag.vue?vue&type=script&lang=js&"
export * from "./AllContractMag.vue?vue&type=script&lang=js&"
import style0 from "./AllContractMag.vue?vue&type=style&index=0&id=1770fa04&scoped=true&lang=css&"
import style1 from "./AllContractMag.vue?vue&type=style&index=1&id=1770fa04&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1770fa04",
  null
  
)

export default component.exports